module.exports = __webpack_public_path__ + "img/info-icon.2d0d6b40.svg";